import styled from 'styled-components';
import { NavButton } from 'components/OrderNavigation/OrderNavigation.styled';

// Shares NavButton so it cannot drift from the order flow's Back. fit-content
// keeps Button's flex wrapper from stretching across the page, which would
// centre the button.
export const StyledBackButton = styled(NavButton)`
  width: fit-content;
`;
